export const getFormId = (roomId: number) =>
  `MESSENGER_TEXTBOX_FORM_ID-${roomId}`;
